export default __webpack_public_path__ + "static/media/logo-color.7fcc5a33.png";